// Libs
import classNames from 'classnames/bind';
import { Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
// Components, Layouts, Pages
// Others
// Styles, images, icons
import styles from './CloneQuoteOption.module.scss';
import { icons } from '~/assets';

type Props = {
  label: string;
  isChecked: boolean;
  onChange: (isChecked: boolean) => void;
};

const cx = classNames.bind(styles);

const CloneQuoteOption = (props: Props) => {
  //#region Destructuring Props
  const { isChecked = false, label, onChange } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation(['common/base']);
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  const handleChecked = () => {
    onChange(!isChecked);
  };
  //#endregion Handle Function

  return (
    <Stack direction={'row'} spacing={'9px'} alignItems={'center'}>
      {isChecked ? (
        <img
          src={icons.commonIconTickActive}
          alt={t('common_alt_img')}
          className={cx('tick')}
          onClick={handleChecked}
        />
      ) : (
        <img src={icons.commonIconTick} alt={t('common_alt_img')} className={cx('tick')} onClick={handleChecked} />
      )}

      <Typography className={cx('text')}>{label}</Typography>
    </Stack>
  );
};

export default CloneQuoteOption;
